import React, { useState, useContext } from "react";
import { string } from "prop-types";
import Popover from "@mui/material/Popover";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Button from "@mui/material/Button";
import "./ZipCodeChecker.scss";
import ZipCodeForm from "./zipcodeform/ZipCodeForm";
import { StoreHeaderDataContext } from "../../../context-api/StoreHeaderDataProvider";
import { MEDIUM_SCREEN, screenSize } from "../../../global/ScreenSizeHelper";
import { localStorageKeys } from "../../../global/constants";
import AddDeliveryAddress from "../../../composed/deliveryaddress/AddDeliveryAddress";
import { DeliveryAddressDataContext } from "../../../context-api/DeliveryAddressDataProvider";
import { LoginDataContext } from "../../../context-api/LoginDataProvider";

const { ZIP_CODE, KITCHEN_NAMES } = localStorageKeys;

const buttonStyleProp = {
  width: "fit-content",
  height: "40px",
  padding: "6px",
  fontSize: "12px",
  lineHeight: "initial",

  flexGrow: 1,
  flexShrink: 1,
};
const zipCodeFormContainerStyle = {
  display: "flex",
  flexDirection: "column",
  padding: "24px",
};
const inputStyles = {
  height: "40px",
  flexGrow: 1,
  flexShrink: 1,
  background: "white"
};

const ZipCodeCheckerDesktop = (props) => {
  const isMediumScreen = screenSize === MEDIUM_SCREEN;
  const { kitchensByZipcode } = useContext(StoreHeaderDataContext) || {};
  const { getDeliveryAddressListResponse } = useContext(DeliveryAddressDataContext);
  const { isLoggedIn, onLogout } = useContext(LoginDataContext);
  let { data, loading, success, zipcode } = kitchensByZipcode;
  const NoAddressFound = getDeliveryAddressListResponse?.errorMessage === 'User donst not exist'

  zipcode = localStorage.getItem(ZIP_CODE)



  const [popOverAnchor, setPopUpAnchor] = useState(null);

  const handleClick = (event) => {
    setPopUpAnchor(event.currentTarget);
  };

  const handleClose = () => {
    setPopUpAnchor(null);
  };

  const open = Boolean(popOverAnchor);
  const id = open ? "zipcode-popover" : undefined;

  return (
    <div
      className={isMediumScreen ? "zip-code-desktop-button medium" : "zip-code-desktop-button"}
      style={{
        display: "flex",
        alignItems: "center",
        flexGrow: 1,
        justifyContent: "flex-start",
        marginLeft: "40px",
      }}
    >
      <Button
        aria-describedby={id}
        onClick={handleClick}
        startIcon={<LocationOnIcon />}
      >
        {!zipcode ? (
          <span className="sub-txt">Enter US zip code</span>
        ) : (
          <span className="success-txt">
            <span className="success-txt sub-txt">Delivery to </span> {zipcode}
          </span>
        )}
      </Button>

      <Popover
        id={id}
        open={open}
        anchorEl={popOverAnchor}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >

        {(NoAddressFound || !isLoggedIn) && <ZipCodeForm
          buttonStyleProp={buttonStyleProp}
          zipCodeFormContainerStyle={zipCodeFormContainerStyle}
          inputStyles={inputStyles}
          data={data}
          loading={loading}
          success={success}
          buttonLabel="Find Food"
        />}

        {isLoggedIn && !NoAddressFound && <AddDeliveryAddress />}

      </Popover>
    </div>
  );
};

export default ZipCodeCheckerDesktop;

ZipCodeCheckerDesktop.propTypes = {
  zipcode: string,
};
ZipCodeCheckerDesktop.defaultProps = {
  zipcode: undefined,
};
